import { InlineFormatBar } from 'components/InlineFormatBar/InlineFormatBar'
import { observer } from 'mobx-react-lite'
import { TextInlineFormatBarProps } from '../../Types'
import { CommentInlineFormatButton } from '../Buttons/CommentInlineFormatButton/CommentInlineFormatButton'

export const ReadOnlyFormatBar = observer((props: TextInlineFormatBarProps) => {
  const { inCommentMode, queryClient, docStore, runItemKey } = props

  if (!docStore?.isVersionControlled && !inCommentMode) {
    return null
  }

  return (
    <InlineFormatBar>
      <CommentInlineFormatButton
        hide={!inCommentMode}
        runItemKey={runItemKey}
        queryClient={queryClient}
        layerId={props.layer.id}
        view={props.view}
        docStore={docStore ?? null}
      />
    </InlineFormatBar>
  )
})
